import api from "../helpers/util";

export const fetchProcessedBodies = async (date) => {
  try {
    const response = await api.post("/processed/bodies/date", {
      productionDate: date,
    });
    console.log("processed bodies", response?.data?.result);
    return response?.data?.result ?? "No bodies processed today.";
  } catch (error) {
    throw new Error("Error fetching processed bodies", error);
  }
};
export const fetchCustomersProcessedBodies = async (customer) => {
  try {
    console.log("model processed bodies, value of customer,", customer);
    const response = await api.post("/processed/bodies/customer", {
      customer: customer,
    });
    console.log("customer's processed bodies", response?.data?.result);
    return response?.data?.result ?? "No bodies processed today.";
  } catch (error) {
    throw new Error("Error fetching customer's  processed bodies", error);
  }
};
